import InternalSubTabs from "./subTabs";
import InternalTabs from "./tabs";

const Tabs = InternalTabs;
Tabs.SubTabs = InternalSubTabs;

export default Tabs;